import { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Wrapper, Heading, Frame, Word, EngWord, UkrWord } from "./VocabularyStyle";
import { fetchVocabWords } from "../../../../features/vocab/vocabSlice";

const Vocabulary = () => {
  const dispatch = useDispatch();
  const currentLesson = useSelector((state) => state.lesson.currentLesson);
  const { words, loading, error } = useSelector((state) => state.vocab);

  // load DB words for this lesson (student mode = /me/words, teacher mode handled elsewhere)
  useEffect(() => {
    if (!currentLesson) return;
    dispatch(fetchVocabWords({ lessonId: currentLesson }));
  }, [dispatch, currentLesson]);

  // local UI state for “show translation”
  const [openIds, setOpenIds] = useState(new Set());

  const clickWord = (e) => {
    const id = Number(e.target.id);
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  // Lesson vocab shows 35 words in your current logic:
  // currentLesson*35-34 .. currentLesson*35
  const selectedWords = useMemo(() => {
    const start = currentLesson * 35 - 34;
    const end = currentLesson * 35;
    return (words || []).filter((w) => w.id >= start && w.id <= end);
  }, [words, currentLesson]);

  return (
    <Wrapper>
      <Heading>Vocabulary</Heading>

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: "red" }}>{String(error)}</p>}

      <Frame>
        {selectedWords.map((value) => (
          <Word key={value.id}>
            <EngWord id={value.id}>
              <span style={{ fontWeight: "bold" }} id={value.id} onClick={clickWord}>
                {value.word}
              </span>{" "}
              <span>{value.word_context}</span>
            </EngWord>

            <UkrWord style={{ visibility: openIds.has(value.id) ? "visible" : "hidden" }}>
              <span style={{ fontWeight: "bold" }}>{value.translat}</span>{" "}
              {value.translat_context}
            </UkrWord>
          </Word>
        ))}
      </Frame>
    </Wrapper>
  );
};

export default Vocabulary;
